import FooterView from './FooterView';
import ImageHeader from './ImageHeader';
import ItemsView from './ItemsView';
import MetaView from './MetaView';
import { $image, $imageHeight, $items, $metadata } from '@/utils/store';
import { useStore } from '@nanostores/react';

export default function IssueForm() {
  const items = useStore($items);
  const meta = useStore($metadata);
  const image = useStore($image);
  const imageHeight = useStore($imageHeight);

  return (
    <div className="print:text-xs">
      <ImageHeader
        image={image}
        imageHeight={imageHeight}
        onChange={img => $image.set(img)}
        onHeightChange={height => $imageHeight.set(height)}
      />
      <table className="w-full">
        <thead>
          <tr>
            <th colSpan={13}>
              <div className="py-2 text-center text-lg font-bold">
                TEMPORARY ISSUE TO AN INDIVIDUAL — PRÊT DE MATÉRIEL À UN
                PARTICULIER
              </div>
              <MetaView meta={meta} onChange={meta => $metadata.set(meta)} />
            </th>
          </tr>
          <tr className="border-r">
            <th
              className="w-0 border-b border-l px-2 text-center text-nowrap text-gray-800 uppercase"
              rowSpan={2}
            >
              Stock number
              <br />
              Numéro de nomenclature
            </th>
            <th
              className="border-b border-l text-center text-gray-800 uppercase"
              rowSpan={2}
            >
              Description — Désignation
            </th>
            <th
              className="border-b border-l text-center text-gray-800 uppercase"
              colSpan={10}
            >
              Quantity — Quantité
            </th>
            <th
              className="border-b border-l text-center text-gray-800 print:hidden"
              rowSpan={2}
            >
              Actions
            </th>
          </tr>
          <tr className="border-r">
            {[...Array(10)].map((_, index) => (
              <th
                key={index}
                className="border-b border-l px-2 text-center text-gray-800"
              >
                {index + 1}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="border-r">
          <ItemsView items={items} onChange={items => $items.set(items)} />
        </tbody>
        <FooterView />
      </table>
    </div>
  );
}
